const messages = {
    notificationSettingsTitle: 'Configuracion de notificaciones',
    notificationSettingsDescription:
        'Administra la activacion de notificaciones y las plantillas SMS almacenadas por las APIs administrativas de Setting.',
    notificationSettingsEnabledSummaryLabel: 'Notificaciones activas',
    notificationSettingsTemplateLimitLabel: 'Limite de caracteres por plantilla',
    notificationSettingsTemplateHelpTitle: 'Guia de plantillas',
    notificationSettingsTemplateHelpBody:
        'Las plantillas tienen un limite de 1000 caracteres. Usa los tokens disponibles debajo de cada plantilla para insertar valores dinamicos. Los tokens no reconocidos por el backend apareceran tal cual en el mensaje enviado.',
    notificationSettingsTemplateStorageHint:
        'Las plantillas permanecen guardadas aun cuando la notificacion esta deshabilitada, para preparar el texto antes de activarla.',
    notificationSettingsReadOnlyNotice:
        'Tienes acceso de lectura a la configuracion de notificaciones, pero solo los usuarios con permiso de actualizacion pueden guardar cambios.',
    notificationSettingsLoading: 'Cargando configuracion de notificaciones...',
    notificationSettingsLoadFailed: 'No se pudo cargar la configuracion de notificaciones.',
    notificationSettingsLoadFailedHelp:
        'Intenta nuevamente cuando la API este disponible o despues de confirmar tus permisos.',
    notificationSettingsRetryButton: 'Reintentar',
    notificationSettingsTemplateLabel: 'Plantilla del mensaje',
    notificationSettingsTemplatePlaceholder: 'Deja el campo vacio para no guardar plantilla.',
    notificationSettingsTemplateFieldHelp:
        'El backend guarda este valor como texto nullable. Si limpias el campo, se elimina la plantilla guardada.',
    notificationSettingsAvailableTokens: 'Tokens disponibles:',
    notificationSettingsUnsavedChanges: 'Tienes cambios sin guardar.',
    notificationSettingsAllChangesSaved: 'No hay cambios pendientes.',
    notificationSettingsReloadButton: 'Recargar desde el servidor',
    notificationSettingsSaveButton: 'Guardar cambios',
    notificationSettingsSavingButton: 'Guardando...',
    notificationSettingsUpdatedSuccessfully:
        'La configuracion de notificaciones se actualizo correctamente.',
    notificationSettingsSectionSecurityTitle: 'Seguridad',
    notificationSettingsSectionSecurityDescription:
        'Notificaciones de identidad y acceso usadas en los flujos de verificacion de cuenta.',
    notificationSettingsSectionAppointmentsTitle: 'Citas del paciente',
    notificationSettingsSectionAppointmentsDescription:
        'Mensajes para pacientes relacionados con confirmaciones, cambios de horario y estado de la visita.',
    notificationSettingsSectionCustomerServiceTitle: 'Servicio al cliente',
    notificationSettingsSectionCustomerServiceDescription:
        'Notificaciones de asignacion y resolucion de incidencias para empleados y managers.',
    notificationSettingsSectionProvidersTitle: 'Proveedores y asistentes',
    notificationSettingsSectionProvidersDescription:
        'Alertas operativas enviadas a proveedores y asistentes de cirugia.',
    notificationSettingsSectionSalesTitle: 'Recibos y pagos',
    notificationSettingsSectionSalesDescription:
        'Mensajes al cliente relacionados con recibos y enlaces de pago desde ventas.',
    notificationSettingsSectionSalesTeamTitle: 'Equipo de ventas',
    notificationSettingsSectionSalesTeamDescription:
        'Notificaciones para vendedores sobre asignacion de leads y cancelacion de citas.',
    notificationSettingsSectionGiftCardsTitle: 'Tarjetas de regalo',
    notificationSettingsSectionGiftCardsDescription:
        'Notificaciones relacionadas con actualizaciones y creacion de saldos en tarjetas de regalo.',
    notificationSettingsSectionQuoteChartsTitle: 'Graficos de cotizacion',
    notificationSettingsSectionQuoteChartsDescription:
        'Notificaciones relacionadas con la creacion de graficos de cotizacion.',
    notificationSettingsTwoFactorTitle: 'Codigo de dos factores',
    notificationSettingsTwoFactorDescription:
        'Envia el codigo de acceso o verificacion requerido para la autenticacion multifactor.',
    notificationSettingsClientTransactionReceiptTitle: 'Recibo de transaccion al cliente',
    notificationSettingsClientTransactionReceiptDescription:
        'Envia un mensaje de recibo despues de eventos de transaccion en ventas.',
    notificationSettingsClientQuoteReceiptTitle: 'Recibo de cotizacion al cliente',
    notificationSettingsClientQuoteReceiptDescription:
        'Envia al cliente los detalles del recibo de cotizacion o factura.',
    notificationSettingsPatientAppointmentConfirmTitle: 'Confirmacion de cita al paciente',
    notificationSettingsPatientAppointmentConfirmDescription:
        'Confirma los detalles de la cita del paciente despues de programarla o confirmarla.',
    notificationSettingsPatientAppointmentCanceledTitle: 'Cita no quirurgica cancelada al paciente',
    notificationSettingsPatientAppointmentCanceledDescription:
        'Avisa al paciente cuando una cita no quirurgica es cancelada.',
    notificationSettingsPatientAppointmentScheduledTitle:
        'Cita no quirurgica programada al paciente',
    notificationSettingsPatientAppointmentScheduledDescription:
        'Avisa al paciente cuando una cita no quirurgica es programada.',
    notificationSettingsPatientSurgeryTimeTitle: 'Hora de cita quirurgica definida',
    notificationSettingsPatientSurgeryTimeDescription:
        'Envia al paciente la hora de su cirugia cuando ya fue configurada.',
    notificationSettingsPatientTurnTitle: 'Paciente llamado con el doctor',
    notificationSettingsPatientTurnDescription:
        'Avisa al paciente cuando es su turno para ver al doctor.',
    notificationSettingsPatientMassageCompletedTitle: 'Masaje del paciente completado',
    notificationSettingsPatientMassageCompletedDescription:
        'Envia un SMS de seguimiento cuando se completa un servicio de masaje.',
    notificationSettingsEmployeeAssignedIncidenceTitle: 'Empleado asignado a incidencia',
    notificationSettingsEmployeeAssignedIncidenceDescription:
        'Notifica al empleado cuando un manager le asigna una incidencia.',
    notificationSettingsManagerComplaintResolvedTitle: 'Manager notificado por queja resuelta',
    notificationSettingsManagerComplaintResolvedDescription:
        'Notifica a los managers cuando un empleado resuelve una queja o seguimiento.',
    notificationSettingsManagerIncentiveResolvedTitle: 'Manager notificado por incentivo resuelto',
    notificationSettingsManagerIncentiveResolvedDescription:
        'Notifica a los managers cuando un empleado resuelve una incidencia de incentivo.',
    notificationSettingsProviderCheckedTitle: 'Proveedor notificado por check-in',
    notificationSettingsProviderCheckedDescription:
        'Notifica al proveedor cuando el paciente ya hizo check-in y esta listo.',
    notificationSettingsProviderCreatedTitle: 'Proveedor notificado por cita creada',
    notificationSettingsProviderCreatedDescription:
        'Notifica al proveedor cuando se crea una nueva cita no quirurgica.',
    notificationSettingsSurgeonAssistantCreatedTitle:
        'Asistente de cirugia notificado por cita creada',
    notificationSettingsSurgeonAssistantCreatedDescription:
        'Notifica a los asistentes de cirugia cuando una cita creada requiere su atencion.',
    notificationSettingsSellerAppointmentCancelledTitle: 'Vendedor notificado por cita cancelada',
    notificationSettingsSellerAppointmentCancelledDescription:
        'Notifica al vendedor cuando una cita asociada a su lead es cancelada.',
    notificationSettingsSellerNewLeadTitle: 'Vendedor notificado por nuevo lead',
    notificationSettingsSellerNewLeadDescription:
        'Notifica al vendedor cuando se le asigna un nuevo lead.',
    notificationSettingsPatientSharePaymentLinkTitle: 'Enlace de pago compartido al paciente',
    notificationSettingsPatientSharePaymentLinkDescription:
        'Envia al paciente el mensaje con enlace de pago compartido desde ventas.',
    notificationSettingsSellerPaymentReceivedTitle: 'Vendedor notificado por pago recibido',
    notificationSettingsSellerPaymentReceivedDescription:
        'Notifica al vendedor cuando se recibe un pago de su lead.',
    notificationSettingsSellerAppointmentModifiedTitle: 'Vendedor notificado por cita modificada',
    notificationSettingsSellerAppointmentModifiedDescription:
        'Notifica al vendedor cuando otro usuario modifica una cita.',
    notificationSettingsSellerAppointmentRejectedTitle: 'Vendedor notificado por cita rechazada',
    notificationSettingsSellerAppointmentRejectedDescription:
        'Notifica al vendedor cuando coordinacion rechaza una cita.',
    notificationSettingsSellerUnpaidReminderTitle: 'Vendedor recordatorio de cita sin pago',
    notificationSettingsSellerUnpaidReminderDescription:
        'Notifica al vendedor sobre citas sin pago que requieren atencion.',
    notificationSettingsGiftCardBalanceUpdatedTitle: 'Saldo de tarjeta de regalo actualizado',
    notificationSettingsGiftCardBalanceUpdatedDescription:
        'Notifica al cliente cuando se actualiza el saldo de su tarjeta de regalo.',
    notificationSettingsGiftCardBalanceCreatedTitle: 'Saldo de tarjeta de regalo creado',
    notificationSettingsGiftCardBalanceCreatedDescription:
        'Notifica al cliente cuando se crea un nuevo saldo en su tarjeta de regalo.',
    notificationSettingsQuoteChartCreatedTitle: 'Grafico de cotizacion creado',
    notificationSettingsQuoteChartCreatedDescription:
        'Notifica a las partes involucradas cuando se crea un grafico de cotizacion.',
    notificationSettingsSellerTreatmentPaymentTitle: 'Pago de tratamiento recibido por vendedor',
    notificationSettingsSellerTreatmentPaymentDescription:
        'Notifica al vendedor asignado cuando se recibe un pago de tratamiento de un paciente mediante venta, pago parcial o enlace de pago.',
    notificationSettingsSendTestButton: 'Enviar prueba',
    notificationSettingsSendTestTitle: 'Enviar notificacion de prueba',
    notificationSettingsSendTestPhoneLabel: 'Numero de telefono',
    notificationSettingsSendTestPhonePlaceholder: 'Numero de telefono de 10 digitos',
    notificationSettingsSendTestPhoneRequired: 'El numero de telefono es obligatorio.',
    notificationSettingsSendTestPhoneInvalid:
        'El numero de telefono debe tener exactamente 10 digitos.',
    notificationSettingsSendTestHint:
        'El SMS de prueba usa valores de ejemplo para los placeholders (ej. {code} se convierte en 123456) y lleva el prefijo [TEST].',
    notificationSettingsSendTestCancelButton: 'Cancelar',
    notificationSettingsSendTestSendButton: 'Enviar',
    notificationSettingsSendTestSendingButton: 'Enviando...',
    notificationSettingsSendTestSuccess: 'Notificacion de prueba enviada correctamente.',
    notificationSettingsChannelLabel: 'Canal de entrega',
    notificationSettingsChannelHelp:
        'Elige como se entrega esta notificacion. Es una opcion de enrutamiento, no un interruptor de encendido/apagado; usa el interruptor para desactivar la notificacion por completo.',
    notificationSettingsChannelSms: 'Solo SMS',
    notificationSettingsChannelSmsDescription:
        'Entrega esta notificacion unicamente por mensaje de texto SMS.',
    notificationSettingsChannelInternal: 'Solo interna',
    notificationSettingsChannelInternalDescription:
        'Entrega esta notificacion unicamente como notificacion interna dentro de la aplicacion.',
    notificationSettingsChannelBoth: 'Ambos',
    notificationSettingsChannelBothDescription:
        'Entrega esta notificacion a traves de los canales SMS e interno.',
};

export default messages;
